export default {
    BagAcceptedDeclaration: 'BagAcceptedDeclaration',
    BagDeliveredToCarouselDeclaration: 'BagDeliveredToCarouselDeclaration',
    BagLoadedOnAircraftDeclaration: 'BagLoadedOnAircraftDeclaration',
    BagReadyForLoadingDeclaration: 'BagReadyForLoadingDeclaration',
    BagMishandledDeclaration: 'BagMishandledDeclaration',
    BagSeenAtStationDeclaration: 'BagSeenAtStationDeclaration',
    BagTransferredToCarrierDeclaration: 'BagTransferredToCarrierDeclaration',
};
